import { buildGlobalAction, buildInlineComputedView } from "./../builder.js";
class HubspotNamespace {
  constructor(clientOrParent) {
    this.clientOrParent = clientOrParent;
    /** Executes the sendEvent global action. */
    this.sendEvent = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "sendEvent",
      operationName: "sendEvent",
      operationReturnType: "HubspotSendEvent",
      namespace: "hubspot",
      variables: {
        apiKeyHubspot: { required: false, type: "String" },
        eventClickUrlHubspot: { required: false, type: "String" },
        userPhoneNumber: { required: false, type: "String" },
        campaignName: { required: false, type: "String" },
        url: { required: false, type: "String" }
      }
    });
    /** Executes an inline computed view. */
    this.view = buildInlineComputedView(this, {
      type: "computedView",
      operationName: "gellyView",
      functionName: "view",
      gqlFieldName: "gellyView",
      namespace: "hubspot",
      variables: {
        query: { type: "String", required: true },
        args: { type: "JSONObject" }
      }
    });
    this.connection = this.clientOrParent.connection;
  }
}
export {
  HubspotNamespace
};
//# sourceMappingURL=hubspot.js.map
